import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import LinearProgress from "@material-ui/core/LinearProgress";
import { CacheProvider } from "rest-hooks";
import { ErrorHandler } from "./components/helpers";
import { SnackbarProvider } from "notistack";

import "@fortawesome/fontawesome-free/css/all.css";

import App from "./App";
import { ThemeProvider, createMuiTheme } from "@material-ui/core";
import { regularTheme } from "./themes";
import { IntlProvider } from "react-intl";
import DateFnsUtils from "@date-io/date-fns";
import nbLocale from "date-fns/locale/nb";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

const theme = createMuiTheme();

ReactDOM.render(
	<ThemeProvider theme={regularTheme(theme)}>
		<IntlProvider locale="nb-NO" defaultLocale="nb-NO">
			<MuiPickersUtilsProvider utils={DateFnsUtils} locale={nbLocale}>
				<React.StrictMode>
					<CssBaseline />
					<ErrorHandler>
						<CacheProvider>
							<SnackbarProvider maxSnack={3}>
								<Suspense
									fallback={
										<>
											<LinearProgress />
										</>
									}
								>
									<App />
								</Suspense>
							</SnackbarProvider>
						</CacheProvider>
					</ErrorHandler>
				</React.StrictMode>
			</MuiPickersUtilsProvider>
		</IntlProvider>
	</ThemeProvider>,
	document.getElementById("root")
);
